
import Vue, { PropType } from "vue";
import { Company } from "@/models";
import { setVacanCompanyId } from "@/api";
import BaseDropDown, { OptionItem } from "@/components/BaseDropDown.vue";
import BaseTableCellContent from "@/components/BaseTableCellContent.vue";

export type DataType = {
  options: OptionItem[];
  showing: boolean;
};

export default Vue.extend({
  name: "CompanyListItem",

  components: {
    BaseDropDown,
    BaseTableCellContent,
  },

  props: {
    company: Object as PropType<Company>,
  },

  computed: {
    editMenuClassText(): string {
      return this.showing ? "active" : "";
    },
    formattedCompanyId(): string {
      return this.company.id?.slice(0, 6) || "";
    },
    buildingName(): string {
      return this.company.facilityName || "";
    },
  },

  data(): DataType {
    return {
      options: [
        {
          label: "編集",
          classes: [],
          clickAction: () => {
            this.$router.push({
              name: "admin-company-detail",
              params: {
                companyId: this.company.id as string,
              },
            });
          },
        },
        {
          label: "削除",
          classes: ["red"],
          clickAction: () => {
            this.$router.push({
              name: "admin-company-delete",
              params: {
                companyId: this.company.id as string,
              },
            });
          },
        },
      ],
      showing: false,
    };
  },

  methods: {
    accessToCompanyPage(): void {
      if (this.company == null) return; // this.$toasted.global.error('予期せぬ不具合が発生しました')
      if (this.company.id == null) return; // this.$toasted.global.error('予期せぬ不具合が発生しました')

      setVacanCompanyId(this.company.id);
      this.$router.push({ path: "/company/gateways" });
    },

    setSelectedCompany(): void {
      const companyId = this.company?.id;
      if (companyId) {
        this.$auth.setCompanyId(companyId);
        this.$globalData.setCompany(this.company);
        this.$router.push({ name: "company-analytics-detail" });
      }
    },
  },
});
